export const generateDiscountArray = () => {
  const discountArray = [-100, -75, -70, -65, -60, -55, -50, -45, -40, -35, -30, -25, -20];

  for (let discount = -15; discount <= 15; discount++) {
    discountArray.push(discount);
  }

  const MAX_POSITIVE_DISCOUNT = 75;

  for (let discount = 20; discount <= MAX_POSITIVE_DISCOUNT; discount += 5) {
    discountArray.push(discount);
  }

  return discountArray;
};